module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$utils.isCartOfflineShippable() && _vm.$utils.getShippingDetail().length > 0) ? _c('div', {
    staticClass: "block"
  }, [_c('strong', [_vm._v("วิธีการรับ" + _vm._s(_vm.$config.PRODUCT_TYPE))]), _vm._v(" "), _c('ul', _vm._l((_vm.$utils.getShippingDetail()), function(detail) {
    return _c('li', [_vm._v(_vm._s(detail))])
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-504b7c74","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeliverySelector.vue
// module id = 1154
// module chunks = 0